import { render, staticRenderFns } from "./SubmissionsPageContainer.vue?vue&type=template&id=c4ef139a&"
import script from "./SubmissionsPageContainer.vue?vue&type=script&lang=js&"
export * from "./SubmissionsPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports